import React, { Component } from 'react';
import analytics from '../../../services/analytics';

import './no-partner.css';

export default class NoPartner extends Component {
  adTitle = 'no-partner';
  redirectUrl = '';

  onClick = () => {
    this.redirectUrl && window.open(this.redirectUrl, '_blank').focus();
    analytics.trackAdClick(this.adTitle);
  }
  
  render() {
    return (
      <div className='ad-container no-partner-container'>
        <div className='no-partner-item'>
          <p>Let us help you reach more audience!</p>
          <p>-- Place your ad here--</p>
          <p>Send us an email to <a href='mailto:dormoshed@gmail.com'>dormoshed@gmail.com</a></p>
        </div>
      </div>
    );
  }
}; 
        // Let us help you to reach more audience!
